"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditCustomAudienceRequestToJSON = exports.EditCustomAudienceRequestFromJSONTyped = exports.EditCustomAudienceRequestFromJSON = exports.instanceOfEditCustomAudienceRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the EditCustomAudienceRequest interface.
 */
function instanceOfEditCustomAudienceRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "audienceType" in value;
    return isInstance;
}
exports.instanceOfEditCustomAudienceRequest = instanceOfEditCustomAudienceRequest;
function EditCustomAudienceRequestFromJSON(json) {
    return EditCustomAudienceRequestFromJSONTyped(json, false);
}
exports.EditCustomAudienceRequestFromJSON = EditCustomAudienceRequestFromJSON;
function EditCustomAudienceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audienceType': json['audience_type'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
    };
}
exports.EditCustomAudienceRequestFromJSONTyped = EditCustomAudienceRequestFromJSONTyped;
function EditCustomAudienceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audience_type': value.audienceType,
        'name': value.name,
        'description': value.description,
    };
}
exports.EditCustomAudienceRequestToJSON = EditCustomAudienceRequestToJSON;
